import { AxiosError } from 'axios';
import { setGlobalErrors, store } from '../../store';
import { ErrorGlobal } from '../../common';

export const handleAxiosError = (err: AxiosError) => {
  const globalErrors = store.getState().globalErrors.data;
  let newError: ErrorGlobal;
  if (err.response?.status === 401) {
    return;
  }
  try {
    newError = {
      code: err.response?.status ?? 999,
      description: '',
      message: err.message,
      // @ts-ignore
      responseMessage: err.response?.data?.message ?? err.response?.statusText,
    };
  } catch (e) {
    newError = {
      code: 999,
      description: '',
      message: err.message,
      responseMessage: err.response?.statusText ?? '',
    };
  }
  store.dispatch(setGlobalErrors([{ ...globalErrors, ...newError }]));
};

export const handleGlobalError = (err: ErrorGlobal) => {
  const globalErrors = store.getState().globalErrors.data;
  store.dispatch(setGlobalErrors([{ ...globalErrors, ...err }]));
};
